
const digest = '9136f366b115305193f5624899be58e7a0620486f7ac1967b3f6136aa14c6e41';
const classes = {"wrapper":"_wrapper_1lgyk_1","form":"_form_1lgyk_8","controls":"_controls_1lgyk_14","toggleButton":"_toggleButton_1lgyk_21","filterInfo":"_filterInfo_1lgyk_30","count":"_count_1lgyk_38"};
const css = `._wrapper_1lgyk_1 {
  display: flex;
  gap: 24px;
  background-color: #fff;
  border: 1px solid #eaedf3;
  padding: 12px;
}
._wrapper_1lgyk_1 ._form_1lgyk_8 {
  flex: 1;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
._wrapper_1lgyk_1 ._controls_1lgyk_14 {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 180px;
  justify-content: flex-end;
}
._wrapper_1lgyk_1 ._controls_1lgyk_14 ._toggleButton_1lgyk_21 {
  display: flex;
  align-items: center;
  gap: 7px;
}
._wrapper_1lgyk_1 ._controls_1lgyk_14 ._toggleButton_1lgyk_21 img {
  width: 18px;
}

._filterInfo_1lgyk_30 {
  display: flex;
  gap: 24px;
  background-color: #fff;
  border: 1px solid #eaedf3;
  border-top: 0;
  padding: 12px;
}
._filterInfo_1lgyk_30 ._count_1lgyk_38 {
  font-weight: 500;
  font-size: 14px;
  color: #1665d8;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  